import { render, staticRenderFns } from "./UserDetailsCapture.vue?vue&type=template&id=9a78a790&scoped=true"
import script from "./UserDetailsCapture.vue?vue&type=script&lang=ts"
export * from "./UserDetailsCapture.vue?vue&type=script&lang=ts"
import style0 from "./UserDetailsCapture.vue?vue&type=style&index=0&id=9a78a790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a78a790",
  null
  
)

export default component.exports